import { render } from "./EdgeData.vue?vue&type=template&id=0a102646&scoped=true"
import script from "./EdgeData.vue?vue&type=script&lang=js"
export * from "./EdgeData.vue?vue&type=script&lang=js"

import "./EdgeData.vue?vue&type=style&index=0&id=0a102646&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a102646"]])

export default __exports__